import React, { useState } from 'react';
import serviceData from '../utils/serviceData';
import { Slide } from "react-awesome-reveal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Services = () => {
    const [services] = useState(serviceData);
    // what to render
    let content = null;
    if (services.length === 0) content = <h4>Loading</h4>
    if (services.length > 0) content =
        <>
            {
                services?.map(({ name, description, icon }, id) =>
                    <div className="col-12 col-md-6 col-lg-4 service text-center" key={id + name}>
                        <Slide direction={id === 0 ? 'left' : id == 2 ? 'right' : ''} duration={2000} distance='70px'>
                            <div className="service-card ">
                                <div className="text-center circle-hover">
                                    <FontAwesomeIcon icon={icon} className="serviceIcon" />
                                </div>
                                <h4 className="serviceName">{name}</h4>
                                <p className="serviceDes">{description}</p>
                                <div className="bookingBox">
                                    <div className="serviceLink" to="#">
                                        <button className="bookingBtn">READ MORE</button>
                                    </div>
                                </div>
                            </div>
                        </Slide>
                    </div>
                )
            }
        </>
    return (
        <section id="services" className="services">
            <h3 className="service-title text-center">SERVICES</h3>
            {services.length === 0 && <div className="spinner text-center d-flex justify-content-center align-items-center">..Loading</div>}
            <div className="container service-container d-flex justify-content-center align-items-center">
                <div className="row mt-2 container mx-auto">
                    {content}
                </div>
            </div>
        </section>
    );
};

export default Services;